module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-resumenes/master-resumenes.component.scss
// module id = ./src/app/master/master-resumenes/master-resumenes.component.scss
// module chunks = main